export const PLAN_ORDER = ["FREE", "BASIC", "PRO"];

export const PLAN_LIMITS = {
  FREE: {
    blogPosts: 10,
    podcasts: 3,
    tests: 5,
    clients: 2,
    groupSessions: 2,
  },
  BASIC: {
    blogPosts: Infinity,
    podcasts: 20,
    tests: 30,
    clients: 7,
    groupSessions: 10,
  },
  PRO: {
    blogPosts: Infinity,
    podcasts: Infinity,
    tests: Infinity,
    clients: Infinity,
    groupSessions: Infinity,
  },
};

export const FEATURE_META = {
  blogPosts: {
    title: "Публикации в блоге",
    action: "создавать новые публикации",
    noun: "публикаций",
  },
  podcasts: {
    title: "Подкасты",
    action: "создавать новые подкасты",
    noun: "подкастов",
  },
  tests: {
    title: "Тесты",
    action: "создавать новые тесты",
    noun: "тестов",
  },
  clients: {
    title: "Клиенты",
    action: "добавлять новых клиентов",
    noun: "клиентов",
  },
  groupSessions: {
    title: "Групповые сессии",
    action: "создавать новые групповые сессии",
    noun: "групповых сессий",
  },
};

export function normalizePlanCode(value) {
  const token = String(value || "").trim().toUpperCase();
  if (!token) return "FREE";
  if (token === "ADVANCED") return "PRO";
  return token;
}

export function planIndex(code) {
  return PLAN_ORDER.indexOf(normalizePlanCode(code));
}

export function nextPlanCode(currentPlanCode) {
  const idx = planIndex(currentPlanCode);
  if (idx < 0) return "BASIC";
  const nextIdx = Math.min(idx + 1, PLAN_ORDER.length - 1);
  return PLAN_ORDER[nextIdx];
}

export function isUnlimited(value) {
  return !Number.isFinite(Number(value));
}

export function getFeatureLimit(planCode, featureKey) {
  const code = normalizePlanCode(planCode);
  const limits = PLAN_LIMITS[code] || PLAN_LIMITS.FREE;
  const raw = limits?.[featureKey];
  if (raw === Infinity) return Infinity;
  const n = Number(raw);
  if (!Number.isFinite(n)) return Infinity;
  return Math.max(0, Math.floor(n));
}

export function getFeatureMeta(featureKey) {
  return FEATURE_META[featureKey] || {
    title: "Функция",
    action: "выполнять это действие",
    noun: "элементов",
  };
}

export function extractTotal(payload, fallback = 0) {
  if (Array.isArray(payload)) return payload.length;
  if (!payload || typeof payload !== "object") return Math.max(0, Number(fallback) || 0);

  const totalCandidates = [
    payload.totalElements,
    payload.total,
    payload.count,
    payload.totalCount,
    payload.meta?.totalElements,
    payload.meta?.total,
    payload.page?.totalElements,
    payload.page?.total,
  ];

  for (const item of totalCandidates) {
    const n = Number(item);
    if (Number.isFinite(n)) return Math.max(0, Math.floor(n));
  }

  const listCandidates = [
    payload.content,
    payload.items,
    payload.data,
    payload.item?.content,
    payload.item?.items,
    payload.item?.data,
    payload.item,
  ];

  for (const list of listCandidates) {
    if (Array.isArray(list)) return list.length;
  }

  return Math.max(0, Number(fallback) || 0);
}

